
export { HighlightDisplayLogic } from "./highlightSection.interfaces"